import React from "react";

export default function BodyDiv(props) {
  return <section className="contentX">{props.children}</section>;
}
